@if (design4) {
  <ng-container [ngTemplateOutlet]="DESIGN_4"></ng-container>
} @else {
  <ng-container [ngTemplateOutlet]="DESIGN_2"></ng-container>
}

<ng-template #DESIGN_2>
  <div fxLayout="row" fxLayoutGap="5px">
    @for (s of flowConfiguration; track s; let i = $index) {
      <a
        [fxFlex]="100 / flowConfiguration.length"
        [ngClass]="{ active: stepIndex === i, filled: stepIndex >= i }"
        [routerLink]="stepIndex >= i ? getRoute(s) : undefined"
      >
        {{ i + 1 + '. ' + s.stepperTitle }}
      </a>
    }
  </div>
</ng-template>

<ng-template #DESIGN_4>
  <div class="progress-wrapper" fxLayout="row" fxLayoutAlign="space-between center">
    <img src="/assets/images/rspl_logo.png" alt="Resupply" />
    <div class="stepper-wrapper" fxLayout="column" fxLayoutGap="5px" fxLayoutAlign="center center">
      @for (s of flowConfiguration; track s; let i = $index) {
        @if (stepIndex === i) {
          <span>{{ i + 1 + '/5' }}</span>
          <span class="step-title">{{ s.stepperTitle }}</span>
        }
      }
      <div fxLayout="row" fxLayoutGap="5px" class="stepper-blocks">
        @for (s of flowConfiguration; track s; let i = $index) {
          <div class="step" [fxFlex]="100 / flowConfiguration.length" [ngClass]="{ active: stepIndex === i, filled: stepIndex >= i }"></div>
        }
      </div>
    </div>
    <button
      class="primary-btn"
      fxLayout="row"
      fxLayoutAlign="center center"
      fxLayoutGap="6px"
      style="padding: 8px 12px"
      (click)="flowService.showZendeskChat()"
    >
      <span>
        <span class="no-mobile">Get</span>
        Help
      </span>
      <mat-icon svgIcon="chat-circle" />
    </button>
  </div>
</ng-template>
